export default __webpack_public_path__ + "static/media/no-img.c2c58b21.jpeg";